@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

.pill {
	$var-borderRadius: 2px;
	$var-imageHeight: 40px;
	$var-imageMaxWidth: 200px;

	border-radius: $var-borderRadius;
	color: Colors.$col-white;
	display: flex;
	width: fit-content;
	font-size: Constants.$val-fontSizeSmall;
	font-weight: bold;
	line-height: Constants.$val-lineHeightRegular;
	padding: 0 Constants.$val-spacing-s;
	align-items: center;

	&--outdated {
		background-color: Colors.$col-orangeBorder;
	}

	&--signed {
		background-color: Colors.$col-blue;
	}

	&--unsigned {
		background-color: Colors.$col-orangeBorder;
	}

	&--approved {
		background-color: Colors.$col-green;
	}

	&--rejected {
		background-color: Colors.$col-red;
	}

	&--modal {
		margin-left: Constants.$val-spacing-s;
	}
}